import { calculateGeneralValues, calculatePrice } from "@/helper/property";

import type { House, LeilaoSQLFull, Modality } from "@/types";

export const sortProfit = (properties: LeilaoSQLFull[]) => {
  return properties
    .map((property) => {
      const price = calculatePrice(property);
      const valorArrematacao = Number(price);
      const valorAvaliacao = Number(property.valor_de_avaliacao);

      const { valor_de_desconto, valor_lucro_liquido_com_corretor } =
        calculateGeneralValues({
          uf: property.uf as House["uf"],
          valor_arrematacao: valorArrematacao,
          valor_avaliacao: valorAvaliacao,
          tipo: property.tipo ?? undefined,
          banco: property.banco,
          modalidade_de_venda: (property.modalidade_de_venda ??
            undefined) as Modality,
        });

      return {
        ...property,
        valor_lucro_liquido_com_corretor,
        valor_de_desconto,
      };
    })
    .sort(
      (a, b) =>
        (b.valor_lucro_liquido_com_corretor ?? 0) -
        (a.valor_lucro_liquido_com_corretor ?? 0)
    );
};
